import React, { Component } from 'react';
import { connect, } from 'react-redux';
import { withRouter } from '../withRouter';
import { addToCart } from 'actions/cart';
import styles from './GameVoteStyles.module.scss'
import { getAddons } from "constants/GameListAdapter"
import placeHolderCard from 'images/gameStorePreviews/placeholder-card.svg';

class GameVote extends Component {
    static displayName = GameVote.name;

    constructor(props) {
        super(props);

        this.state = {
            game: null,
            gameAddons: this.getAddons(),
        };
    }

    getAddons() {
        // Get addons that belong to this game (their gameId is in this game's addonIds)
        const gameAddonIds = this.props.game?.addonIds || [];
        return getAddons().filter((a) => gameAddonIds.includes(a.gameId)).map((a) => {
            const owned = a.price === 0 || (this.props.addons && this.props.addons.find(ownedAddon => ownedAddon.code === a.gameId) ? true : false);
            return { ...a, owned }
        });
    }

    componentDidMount() {

    }

    isDev() {
        return !process.env.REACT_APP_ENVIRONMENT || process.env.REACT_APP_ENVIRONMENT === 'development';
    }

    getCardStyling() {
        // Lobby context: Use gameCard from Game entity (gameplay visuals)
        // Note: storeCard is available for store contexts but this component is lobby-only
        const cardImage = this.props.game?.meta?.gameCard || placeHolderCard;
        return {
            backgroundImage: `url(${cardImage})`
        }
    }

    hasPlaceholderCard() {
        return !this.props.game?.meta?.gameCard;
    }

    getCardPriceBannerStyling() {
        return {
            background: this.props.game?.meta.cardPriceColour
        }
    }

    getButtonStyling() {
        return {
            background: this.props.game.meta.storeAccentColour
        }
    }

    getAddonText() {
        const ownedCount = this.state.gameAddons.filter(a => a.owned).length;
        const availableCount = this.state.gameAddons.length - ownedCount;
        let text = "Add-ons: "
        text += ownedCount !== 0 ? `${ownedCount} owned` : "";
        if (ownedCount > 0 && availableCount > 0) text += ", "
        text += availableCount !== 0 ? `${availableCount} available` : "";
        return text;
    }

    getAdditionalStyles() {
        if (this.props.game?.name === "Playing With Fire") {
            return {
                width: '75%',
            }
        }
    }
    render() {
        let gameVotes = 0;
        if (this.props.game) gameVotes = this.props.room.players.filter((player) => player.gameVote == this.props.game.gameId).length;
        
        return (
            this.props.game &&
            <div className={`${styles.gameVoteCard} ${this.props.selected && styles.selected} ${!this.props.supported && styles.unsupported}`} style={this.getCardStyling()} onClick={() => this.props.clickEvent(this.props.game)}>
                {
                    this.isDev() && this.props.game.status === 'disabled' &&
                    <div className={styles.devBadges}>
                        <div className={styles.devBadge}>DISABLED</div>
                    </div>
                }
                {
                    this.hasPlaceholderCard() &&
                    <div className={styles.placeholderName}>{this.props.game.name}</div>
                }
                {
                    this.props.showVotes && gameVotes > 0 &&
                    <div className={styles.votesCounter} style={this.getCardPriceBannerStyling()}><span>{gameVotes}</span></div>
                }
                {/*{this.state.gameAddons.length > 0 &&*/}
                {/*    <div className={styles.availableAddons} style={this.getButtonStyling()}>{this.getAddonText()}</div>*/}
                {/*}*/}
            </div>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        room: state.room,
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        addToCart: (game) => {
            dispatch(addToCart(game))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(GameVote));
